import '../fesd/fesd'
import '../../sass/news/news.sass'
import { _dropdown } from '../includes/_dropdown.js'

let _news = {
  all() {
    _common.commonSwiper('.news-swiper');
    _common.newsSetType();
  }
}

// 後端用
window._common.newsCallback = (() => {
  _common.newsSetType();
  _common.bLazy;
  $('[data-aost]').aost4();
})

$(function(){
  _news.all();
  _dropdown.all();
});
